import { Variants } from 'motion/react'

export const subRowVariants = {
  hidden: { opacity: 0, height: 0 },
  visible: { opacity: 1, height: 'auto' },
} satisfies Variants
